import { render, staticRenderFns } from "./ClaioSchemaFinder.vue?vue&type=template&id=c2deb58c&scoped=true&"
import script from "./ClaioSchemaFinder.vue?vue&type=script&lang=ts&"
export * from "./ClaioSchemaFinder.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioSchemaFinder.vue?vue&type=style&index=0&id=c2deb58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2deb58c",
  null
  
)

export default component.exports